import { useMemo } from "react";
import {
  selectMostCookedRecipes,
  formatLastCooked,
  selectLocale,
  MOST_COOKED,
  useT,
  useAppSelector,
} from "@reciperoll/core";
import { Link } from "react-router-dom";
import { Repeat, ChevronRight, RotateCcw } from "react-feather";
import { SectionHeader } from "./SectionHeader";
import { RecipeImage } from "../RecipeImage";

const LIMIT = 3;

// Your most-cooked recipes as a compact list (with a cook-count) — a text-forward
// block that breaks up the image rails. Hidden until you've cooked. Mirrors RN.
export default function CookItAgain() {
  const t = useT();
  const locale = useAppSelector(selectLocale);
  const select = useMemo(() => selectMostCookedRecipes(LIMIT), []);
  const items = useAppSelector(select);
  if (items.length === 0) return null;

  return (
    <div className="mb-8">
      <SectionHeader
        title={t("home.cookItAgain")}
        icon={<RotateCcw className="w-5 h-5" />}
        link={`/recipes?sort=${encodeURIComponent(MOST_COOKED)}`}
      />
      <div className="rounded-2xl border border-line bg-surface overflow-hidden divide-y divide-line">
        {items.map(({ recipe, count, lastCookedAt }) => (
          <Link
            key={recipe.id}
            to={`/recipe/${recipe.id}`}
            className="flex items-center px-4 py-3 group hover:bg-surface-2 transition-colors"
          >
            <div className="w-14 h-14 rounded-xl overflow-hidden bg-terracotta-wash shrink-0">
              <RecipeImage recipe={recipe} />
            </div>
            <div className="flex-1 min-w-0 ml-3">
              <p className="text-base font-bold text-ink truncate group-hover:text-terracotta-ink transition-colors">
                {recipe.title}
              </p>
              <div className="flex items-center gap-1 mt-0.5 text-sm text-ink-soft">
                <Repeat className="w-3 h-3 shrink-0" />
                <span className="truncate">
                  {t("home.cookedTimes", { count })} · {formatLastCooked(lastCookedAt, locale)}
                </span>
              </div>
            </div>
            <ChevronRight className="w-5 h-5 text-ink-faint shrink-0" />
          </Link>
        ))}
      </div>
    </div>
  );
}
